import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(15),
  gap: 15,
  backgroundColor: theme.palette.white,
  borderRadius: 10,
  border: `1px solid ${theme.palette.fly.brandBorder}`,
}));

export const BlockTitle = styled("h3")(({ theme }) => ({
  color: theme.palette.text.primary,
  borderBottom: `1px solid ${theme.palette.fly.hairlineLight}`,
  fontWeight: 600,
  paddingBottom: 10,
}));

export const PaymentMethodsBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 10,
  // display: "grid",
  // gridTemplateColumns: "repeat(4, 1fr)",
  // gap: 5,

  // [theme.down("xl")]: {
  //   gridTemplateColumns: "repeat(3, 1fr)",
  // },

  // [theme.down("sm")]: {
  //   gridTemplateColumns: "repeat(2, 1fr)",
  // },

  // [theme.down("xs")]: {
  //   gridTemplateColumns: "1fr",
  // },
}));

export const PaymentMethodItem = styled("div")(({ theme, $isActive }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(10),
  gap: 5,
  justifyContent: "center",
  alignItems: "flex-start",
  position: "relative",
  backgroundColor: theme.palette.white,
  border: `1px solid ${$isActive ? theme.palette.fly.brand : "#CDCDCD"}`,
  borderRadius: 6,
  cursor: "pointer",
  transition: "all .3s ease-out",

  "& .balance-icon": {
    display: "flex",
    fontSize: 32,
  },

  "& .balance-not-enough": {
    ...theme.mixins.flexCenterCenter,
    fontSize: 12,
    color: theme.palette.searchButtonBg,
  },

  "&:hover": {
    borderColor: "#2563EB",
    boxShadow: "0 2px 8px rgba(37, 99, 235, 0.15)",
  },
}));

export const PaymentMethodCheckboxBlock = styled("div")(({ theme }) => ({
  position: "absolute",
  right: 5,
  top: "center",
}));

export const PaymentMethodLogoContainer = styled("div")(({ theme }) => ({
  width: 90,
  height: 48,

  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const PaymentMethodLogo = styled("img")(({ theme }) => ({
  width: "100%",
  height: "auto",
  display: "block",
  maxWidth: 90,
  maxHeight: 48,

  [theme.down("xs")]: {
    maxWidth: 80,
  },
}));

export const PaymentMethodDescription = styled("div")(({ theme, $isActive }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: $isActive ? theme.palette.text.primary : theme.palette.text.muted,
}));

// Предупреждение о невыписанном билете стоит в одной карточке с таймером:
// именно истечение таймлимита и снимает зафиксированную цену, о чём текст и говорит.
export const NotTicketedWarning = styled("div")(({ theme }) => ({
  ...theme.paddings(12),
  fontSize: 13,
  lineHeight: 1.5,
  textAlign: "left",
  color: theme.palette.warning.dark,
  backgroundColor: theme.palette.warning.lighter,
  border: `1px solid ${theme.palette.warning.border}`,
  borderRadius: 6,

  [theme.down("sm")]: {
    fontSize: 12,
  },
}));

export const TimelimitAndPaymentButtonBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  flexDirection: "column",
  gap: 10,
  fontSize: 14,
  color: theme.palette.text.primary,
}));

export const TimelimitWarning = styled("div")(({ theme }) => ({
  ...theme.paddings(10, 12),
  fontSize: 13,
  lineHeight: 1.45,
  textAlign: "left",
  color: theme.palette.warning.dark,
  backgroundColor: theme.palette.warning.bg,
  border: `1px solid ${theme.palette.warning.light}`,
  borderRadius: 8,
}));

export const PaymentButton = styled("button")(({ theme, $isMuted }) => ({
  ...theme.mixins.flexCenterCenter,
  ...theme.paddings(0, 15),
  position: "relative",
  fontSize: 18,
  fontWeight: 600,
  border: "none",
  borderRadius: 8,
  backgroundColor: $isMuted ? theme.palette.text.muted : theme.palette.button.primary,
  color: theme.palette.white,
  height: 46,
  width: "100%",
  cursor: $isMuted ? "not-allowed" : "pointer",
  pointerEvents: $isMuted ? "none" : "auto",

  transition: "all .3s ease-out",

  "&:hover": {
    backgroundColor: $isMuted ? theme.palette.text.muted : theme.palette.button.primaryHover,
  },
}));

export const PaymentButtonLoadingCover = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: theme.palette.footerBg,
}));
